module.exports = __webpack_public_path__ + "static/img/8.5f3158b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/8.jpg
// module id = Lptz
// module chunks = 0